/* Aico Story Gallery — Instagram-stories-style gallery: preview card autoplays in view;
   modal plays items in sequence with progress bars, nav buttons, tap-halves and keyboard. */
(function () {
  'use strict';

  function initSection(root) {
    if (!root || root.dataset.sgInit === '1') return;
    root.dataset.sgInit = '1';

    var openBtn = root.querySelector('[data-sg-open]');
    var modal = root.querySelector('[data-sg-modal]');
    var preview = root.querySelector('[data-sg-preview]');

    /* ---- Preview card: load after page load, autoplay in view ---- */
    if (preview) {
      var startPreview = function () {
        try { preview.load(); } catch (e) {}
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                preview.play().catch(function () {});
              } else {
                preview.pause();
              }
            });
          }, { threshold: 0.4 });
          io.observe(preview);
        } else {
          preview.play().catch(function () {});
        }
      };
      if (document.readyState === 'complete') startPreview();
      else window.addEventListener('load', startPreview, { once: true });
    }

    if (!modal) return;

    var items = Array.prototype.slice.call(modal.querySelectorAll('[data-sg-item]'));
    var bars = Array.prototype.slice.call(modal.querySelectorAll('[data-sg-bar] > i'));
    if (!items.length) return;

    var current = -1;
    var paused = false;
    var imgTimer = null;
    var imgDur = 5;          // seconds
    var imgRemaining = null; // seconds remaining while paused

    function clearImgTimer() {
      if (imgTimer) { clearTimeout(imgTimer); imgTimer = null; }
    }

    function activeMedia() {
      return current >= 0 && items[current]
        ? items[current].querySelector('[data-sg-media]')
        : null;
    }

    /* Progress bars fill with a CSS linear transition (smooth), not per-frame JS. */
    function resetBars() {
      for (var i = 0; i < bars.length; i++) {
        bars[i].style.transition = 'none';
        bars[i].style.width = i < current ? '100%' : '0%';
      }
    }

    function barFraction(bar) {
      if (!bar || !bar.parentElement) return 0;
      var full = bar.parentElement.clientWidth;
      var cur = parseFloat(getComputedStyle(bar).width) || 0;
      return full ? Math.min(cur / full, 1) : 0;
    }

    function fillBar(bar, durationSec) {
      if (!bar || !(durationSec > 0)) return;
      bar.style.transition = 'none';
      bar.style.width = '0%';
      void bar.offsetWidth; // reflow so the transition runs from 0
      bar.style.transition = 'width ' + durationSec + 's linear';
      bar.style.width = '100%';
    }

    function resumeBar(bar, remainingSec) {
      if (!bar) return;
      void bar.offsetWidth;
      bar.style.transition = 'width ' + Math.max(remainingSec, 0) + 's linear';
      bar.style.width = '100%';
    }

    function freezeBar(bar) {
      if (!bar) return;
      var frac = barFraction(bar);
      bar.style.transition = 'none';
      bar.style.width = (frac * 100) + '%';
    }

    var prefetched = false;

    // Switch every video to eager buffering (background after load + on open).
    function prefetchVideos() {
      if (prefetched) return;
      prefetched = true;
      items.forEach(function (item) {
        var m = item.querySelector('[data-sg-media]');
        if (m && m.tagName === 'VIDEO') {
          m.preload = 'auto';
          try { m.load(); } catch (e) {}
        }
      });
    }

    // Buffer only after window load, during idle, so page load isn't affected (skip on Save-Data/2G).
    function scheduleBackgroundPrefetch() {
      var conn = navigator.connection;
      if (conn && (conn.saveData || /(^|\b)2g\b/.test(conn.effectiveType || ''))) return;
      var run = function () {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(prefetchVideos, { timeout: 4000 });
        } else {
          setTimeout(prefetchVideos, 1500);
        }
      };
      if (document.readyState === 'complete') run();
      else window.addEventListener('load', run, { once: true });
    }

    function open() {
      document.documentElement.classList.add('aico-sg-lock');
      modal.hidden = false;
      // force reflow so the open transition runs
      void modal.offsetWidth;
      modal.classList.add('is-open');
      // Guarantee buffering has started (no-op if the background prefetch already ran)
      prefetchVideos();
      goTo(0);
    }

    function close() {
      clearImgTimer();
      var m = activeMedia();
      if (m && m.tagName === 'VIDEO') { try { m.pause(); } catch (e) {} }
      if (items[current]) items[current].classList.remove('is-active');
      modal.classList.remove('is-open');
      modal.hidden = true;
      document.documentElement.classList.remove('aico-sg-lock');
      current = -1;
    }

    function goTo(index) {
      clearImgTimer();

      // tear down previous
      if (current >= 0 && items[current]) {
        var pm = items[current].querySelector('[data-sg-media]');
        if (pm && pm.tagName === 'VIDEO') { try { pm.pause(); } catch (e) {} pm.onended = null; pm.onerror = null; }
        items[current].classList.remove('is-active');
      }

      if (index >= items.length) { close(); return; }
      if (index < 0) index = 0;

      current = index;
      resetBars();

      // Each new story starts playing
      paused = false;
      if (pauseBtn) { pauseBtn.classList.remove('is-paused'); pauseBtn.setAttribute('aria-label', 'Pause'); }

      // Disable the lateral buttons at the ends (they must never close the gallery)
      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current === items.length - 1;

      var item = items[current];
      item.classList.add('is-active');
      var media = item.querySelector('[data-sg-media]');
      var bar = bars[current];

      if (item.getAttribute('data-type') === 'video' && media) {
        try { media.currentTime = 0; } catch (e) {}
        media.muted = false;
        media.onended = function () { goTo(current + 1); };
        media.onerror = function () { goTo(current + 1); };

        // Fill the bar over the real duration (CSS transition); advance on 'ended'.
        var startBar = function () {
          if (paused || items[current] !== item) return;
          var d = (media.duration && isFinite(media.duration)) ? media.duration : 0;
          fillBar(bar, d);
        };
        if (media.readyState >= 1 && media.duration && isFinite(media.duration)) startBar();
        else media.addEventListener('loadedmetadata', startBar, { once: true });

        var p = media.play();
        if (p && p.catch) p.catch(function () { media.muted = true; media.play().catch(function () {}); });
      } else {
        imgDur = parseFloat(item.getAttribute('data-duration')) || 5;
        fillBar(bar, imgDur);
        imgTimer = setTimeout(function () { goTo(current + 1); }, imgDur * 1000);
      }
    }

    function setPaused(p) {
      if (current < 0 || !items[current]) return;
      paused = p;
      if (pauseBtn) {
        pauseBtn.classList.toggle('is-paused', p);
        pauseBtn.setAttribute('aria-label', p ? 'Play' : 'Pause');
      }
      var item = items[current];
      var media = item.querySelector('[data-sg-media]');
      var isVideo = item.getAttribute('data-type') === 'video';
      var bar = bars[current];

      if (p) {
        freezeBar(bar);
        clearImgTimer();
        if (isVideo && media) { try { media.pause(); } catch (e) {} }
        else { imgRemaining = imgDur * (1 - barFraction(bar)); }
      } else {
        if (isVideo && media) {
          var d = (media.duration && isFinite(media.duration)) ? media.duration : 0;
          resumeBar(bar, d > 0 ? Math.max(d - media.currentTime, 0) : 0);
          media.play().catch(function () {});
        } else {
          var rem = (imgRemaining != null) ? imgRemaining : imgDur;
          resumeBar(bar, rem);
          imgTimer = setTimeout(function () { goTo(current + 1); }, rem * 1000);
        }
      }
    }

    /* ---- wiring ---- */
    if (openBtn) openBtn.addEventListener('click', open);

    modal.querySelectorAll('[data-sg-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });

    var prevBtn = modal.querySelector('[data-sg-prev]');
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });

    var nextBtn = modal.querySelector('[data-sg-next]');
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    var pauseBtn = modal.querySelector('[data-sg-pause]');
    if (pauseBtn) pauseBtn.addEventListener('click', function () { setPaused(!paused); });

    modal.querySelectorAll('[data-sg-half]').forEach(function (half) {
      half.addEventListener('click', function () {
        goTo(half.getAttribute('data-sg-half') === 'prev' ? current - 1 : current + 1);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') goTo(current - 1);
      else if (e.key === 'ArrowRight') goTo(current + 1);
    });

    // Kick off background buffering of the gallery videos after the page loads
    scheduleBackgroundPrefetch();
  }

  function init() {
    document.querySelectorAll('[data-aico-sg]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: (re)initialise sections added/reloaded in the customizer
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('[data-aico-sg]') : null;
    if (el) initSection(el);
  });
})();
